import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SharedApiService } from '../../../shared/service/util.service';
import { SettingsModel } from '../../../shared/Model/setting.model';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  private endpoint = `Setting/GetAll`

  private sharedApiService = inject(SharedApiService)

  getAllSettings(): Observable<{ value: SettingsModel[] }> {
    return this.sharedApiService.getAll(this.endpoint);
  }
}
